const SchoolsTableColumns = [
    { id: 'image', labelAr: 'الشعار', labelEn: 'Logo', width: 90 },
    { id: 'code', labelAr: 'الكود', labelEn: 'Code', width: 100 },
    { id: 'name', labelAr: 'اسم المدرسة', labelEn: 'School Name' },
    { id: 'email', labelAr: 'البريد الإلكتروني', labelEn: 'Email' },
    { id: 'phone', labelAr: 'الهاتف', labelEn: 'Phone' },
    { id: 'is_active', labelAr: 'الحالة', labelEn: 'Status', width: 120 },
];

export default SchoolsTableColumns;
